import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Presentational left-hand brand panel shared by every step of the sign-in flow
 * (email entry and password entry). Renders the TeamLease RegTech brand mark, the
 * "trusted by" strip, the compliance-dashboard illustration, the "Did you know?"
 * card, and the support-email footer.
 *
 * Purely presentational: no inputs/outputs, no service calls. Kept as a shared
 * component (rather than duplicated markup) because both consuming pages render
 * the exact same panel.
 * @component
 * @selector app-auth-brand-panel
 * @example
 *   <app-auth-brand-panel></app-auth-brand-panel>
 */
@Component({
  selector: 'app-auth-brand-panel',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './auth-brand-panel.component.html',
  styleUrl: './auth-brand-panel.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthBrandPanelComponent {
  /** Star icons used by the trusted-by strip. */
  readonly trustStars = [1, 2, 3, 4, 5];

  /** Index-based trackBy so the star icons keep their DOM identity across re-renders. */
  trackByStar(index: number): number {
    return index;
  }
}
